import React from 'react';
import { useApp } from '../context/AppContext';

const Notification = () => {
  const { notification, dismissNotification } = useApp();
  if (!notification) return null;

  return (
    <div className={`notification notification-${notification.type}`}>
      <span>{notification.message}</span>
      <button className="notification-close" onClick={dismissNotification} aria-label="Dismiss">
        &times;
      </button>
    </div>
  );
};

export default Notification;
